module.exports = __webpack_public_path__ + "static/media/bio-3@2x.2e7409ef.jpg";